import { useLocation, Navigate, Link } from "react-router-dom";
import { Layout } from "../Layout";

interface LocationState {
  email: string;
}

interface VerifyPromptProps {
  title?: string;
  message?: string;
  wrongEmailHref?: string;
}

export function VerifyPrompt({
  title = "Verify your email",
  message = "Click on the link to verify your email.",
  wrongEmailHref = "/signup",
}: VerifyPromptProps) {
  const location = useLocation();
  const state = location.state as LocationState;

  if (!state?.email) {
    return <Navigate to="/signup" replace />;
  }

  return (
    <Layout width="400px">
      <div className="row flex-grow-1 justify-content-center">
        <div className="d-flex flex-column justify-content-between col-md-12">
          <div>
            <img
              src="/birdie_logo.svg"
              alt="Company Logo"
              style={{ height: "40px" }}
            />
          </div>
          <div style={{ marginTop: "-40px" }}>
            <div className="font-size-large font-weight-bold mb-2">{title}</div>
            <div className="mb-2">
              We've sent an email to <strong>{state.email}</strong>. {message}
            </div>
            <div>If you don't see the email, check your spam folder.</div>
          </div>
          <div className="text-end">
            <Link
              to={wrongEmailHref}
              className="btn btn-secondary text-decoration-none"
            >
              Wrong email?
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}
